import { createSelector } from "reselect";
const selector = (state) => state.reservations;

export default createSelector([selector], (data) => data);